import Modal from "react-modal";
import SelectList from "../../../../components/SelectList";
import { useEffect, useRef, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { BiSearch } from "react-icons/bi";
import "./style.css";
import { getItemShopComService } from "../../../../services/shopcom.service";
import {
  setInteractionData,
  setShopComAllData,
} from "../../interaction.actions";
import useAppAccessor from "../../../../hooks/useappAccessor";
import SelectListBrand from "../selectListBrand";
import SelectListCategories from "../selectListCategories";
import { InteractionData } from "../../interaction.interface";
import { TfiClose } from "react-icons/tfi";
import {
  payloadShopComSite,
  payloadLumiereSite,
  payloadTransitionsSite,
  payloadMotivesSite,
  payloadIsotonixSite,
  payloadLayeredSite,
  payloadNatrixSite,
} from "./constants";
import SelectListCategoriesSub from "../selectListCategorySub";
import { saveInteractionAPI } from "../../../../services/record.service";
import NoResult from "../../../../components/NoResult";
import { toast } from "react-toastify";
import { callEvent } from "../../../../services/main.service";
import { getBrandColor } from "../../../../utils/brand.util";
import { isMarketAmericaShopUrl, getMarketAmericaMarketName } from "../../../../utils/marketAmerica.util";
import { debounce } from 'lodash'; // 确保你已经安装了 lodash

let listenerAdded:boolean = false;
let timeoutId:any = null;
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    height: "calc(var(--vh, 1vh) * 85)",
    width: "80%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: 0,
    border: 0,
    backgroundColor: "#000000",
    transform: "translate(-50%, -50%)",
    overflow: "hidden",
    position: "absolute" as const,
  },
  overlay: {
    backgroundColor: "rgba(24, 24, 24,0.8)",
    zIndex: 99999,
    position: "fixed" as const,
  },
};

function InteractionShop(props: any) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { getInteractions, getLiveMainData, getUserData } = useAppAccessor();
  const { interactionData, shopSiteName, shopComAllData } = getInteractions();
  const { configurationData } = getLiveMainData();
  const { joinWithAttendeeData,createStreamData, hostTime } = getLiveMainData();
  const {client} = getUserData();
  const { user } = getUserData();
  const { publicUserData } = user;
  const [interactionDataArray, setInteractionDataArray] = useState<
    InteractionData[]
  >([]);
  const time = Date.now();

  const [productsDetailData, setProductsDetailData] = useState([]);
  const [productMoreData, setProductMoreData] = useState<any>([]);

  const [productsBrandTotal, setProductsBrandTotal] = useState(null);
  const [productsBrandTemp, setProductsBrandTemp] = useState<any>(null);

  const [productsCategoryTotal, setProductsCategoryTotal] = useState<any>(null);
  const [productsCategoryTemp, setProductsCategoryTemp] = useState<any>(null);

  const [productsCategorySub, setProductsCategorySub] = useState<any>(null);
  const [productsCategorySubTemp, setProductsCategorySubTemp] =
    useState<any>(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [payloadShopSite, setPayloadShopSite] = useState<any>(null);
  const [count, setCount] = useState(0);
  const [selectedItems, setSelectedItems] = useState<any>([]);
  const childeBrandRef = useRef<any>();
  const childeCatRef = useRef<any>();
  const childeSubCatRef = useRef<any>();
  const inputRef = useRef<HTMLInputElement>(null);

  const [isDataFetched, setIsDataFetched] = useState(false);
  const { language } = getUserData();

  //   function openModal() {
  //     setIsOpen(true);
  //   }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  function closeModal() {
    // 清空搜索相关的状态
    setSearchTerm('');
    setProductMoreData([]);
    setProductsDetailData([]);
    if (inputRef.current) {
      inputRef.current.value = '';
    }
    setCount(0);
    
    // 重置筛选条件
    setProductsBrandTemp(null);
    setProductsCategoryTemp(null);
    setProductsCategorySubTemp(null);
    
    // 重置其他状态
    listenerAdded = false;
    timeoutId = null;
    
    // 关闭模态框
    props.handleCloseMediaInteraction(false);
  }

  function searchItems(items: any, searchTerm: any) {
    return items?.filter((item: any) => {
      return item.name.toLowerCase().includes(searchTerm.toLowerCase());
    });
  }

  function handleSelectBrand() {
    setLoading(true);
    if (productsBrandTemp) {
      const updatedPayload = {
        ...payloadShopSite,
        term: searchTerm,
        brandId: productsBrandTemp?.brandId,
        categoryId: "",
      };
      if (updatedPayload && updatedPayload['vendor_id'] === 'shop.com')
      getItemShopComService(updatedPayload)
        .then((item: any) => {
          dispatch(setShopComAllData(item));
          setProductsCategoryTotal(item["categories"]);
          setProductsCategorySub("Select Sub Categories");
          setLoading(false);
        })
        .catch((err) => {
         // console.log("API shop COM error:", err);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }

  // 创建一个新的函数来处理搜索
  const handleFilterData = useCallback(() => {
    setCount(0);
    const currentSearchTerm = inputRef.current?.value || '';
    setLoading(true);
    const updatedPayload = {
      ...payloadShopSite,
      term: currentSearchTerm,
      brandId: productsBrandTemp?.brandId,
      categoryId: productsCategorySubTemp?.categoryId,
    };
    if (updatedPayload && updatedPayload['vendor_id'] === 'shop.com')
    getItemShopComService(updatedPayload)
      .then((item: any) => {
        dispatch(setShopComAllData(item));
        setProductsCategoryTotal(item["categories"]);
        setProductsCategorySub("Select Sub Categories");
        setLoading(false);
      })
      .catch((err: any) => {
       // console.log("API shop COM error:", err);
        setLoading(false);
      });
  }, [payloadShopSite, productsBrandTemp, productsCategorySubTemp]);

  // 使用防抖
  // const debouncedHandleFilterData = useCallback(
  //   debounce(handleFilterData, 300),
  //   [handleFilterData]
  // );


  function handleSelectCategory() {
    setLoading(true);
    if (productsCategoryTemp) {
      const updatedPayload = {
        ...payloadShopSite,
        brandId: productsBrandTemp?.brandId,
        categoryId: productsCategoryTemp?.categoryId,
        term: searchTerm,
      };
      if (updatedPayload && updatedPayload['vendor_id'] === 'shop.com')
      getItemShopComService(updatedPayload)
        .then((item: any) => {
          setProductsCategorySub(item["categories"]);
          dispatch(setShopComAllData(item));
          setLoading(false);
        })
        .catch((err) => {
         // console.log("API shop COM error:", err);
        });
    } else {
      setLoading(false);
    }
  }

  function handleSelectCategorySub() {
    setLoading(true);
    if (productsCategorySubTemp && productsBrandTemp) {
      const updatedPayload = {
        ...payloadShopSite,
        brandId: productsBrandTemp?.brandId,
        categoryId: productsCategorySubTemp?.categoryId,
        term: searchTerm,
      };
      if (updatedPayload && updatedPayload['vendor_id'] === 'shop.com')
      getItemShopComService(updatedPayload)
        .then((item) => {
          dispatch(setShopComAllData(item));
          setLoading(false);
        })
        .catch((err) => {
         // console.log("API shop COM error:", err);
        });
    } else {
      setLoading(false);
    }
  }

  function handleSelectItem(items: any) {
   // console.log("isSelecte===>", items);
    const isSelected = selectedItems.includes(items);

    if (isSelected) {
      setSelectedItems(
        selectedItems.filter((selectedItem: any) => selectedItem !== items)
      );
    } else {
     // console.log("is ItemPresent==>", checkElementPresentInArray(items?.id));
      if (!checkElementPresentInArray(items?.id)) {
        setSelectedItems([...selectedItems, items]);
      } else {
        toast(`${items.name} ${language['already_in_interactions']}.`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    }
  }

  function checkShopSite(site: any) {
    var locale = publicUserData?.locale;
    switch (site) {
      case "shopcomesite": {
        payloadShopComSite["locale"] = locale;
        return setPayloadShopSite(payloadShopComSite);
      }
      case "isotonix": {
        payloadIsotonixSite["locale"] = locale;
        return setPayloadShopSite(payloadIsotonixSite);
      }
      case "layered": {
        payloadLayeredSite["locale"] = locale;
        return setPayloadShopSite(payloadLayeredSite);
      }
      case "lumiere": {
        payloadLumiereSite["locale"] = locale;
        return setPayloadShopSite(payloadLumiereSite);
      }
      case "motives": {
        payloadMotivesSite["locale"] = locale;
        return setPayloadShopSite(payloadMotivesSite);
      }
      case "tls": {
        payloadTransitionsSite["locale"] = locale;
        return setPayloadShopSite(payloadTransitionsSite);
      }

      case "nutraMetrix": {
        payloadNatrixSite["locale"] = "en_US";
        return setPayloadShopSite(payloadNatrixSite);
      }

      default:
        return site;
    }
  }

  function checkShopSiteTitle(siteName: any) {
    switch (siteName) {
      case "shopcomesite": {
        return getMarketAmericaMarketName(publicUserData?.locale);
      }
      case "nutraMetrix": {
        return "NUTRAMETRIX";
      }
      case "isotonix": {
        return "ISOTONIX";
      }
      case "layered": {
        return "LAYERED";
      }
      case "lumiere": {
        return "LUMIÈRE";
      }
      case "motives": {
        return "MOTIVES";
      }
      case "tls": {
        return "GoTrim";
      }

      default:
        return siteName;
    }
  }

  function getMoreItem() {
    setCount(prevCount => {
      const newCount = prevCount + 20;
      const currentSearchTerm = inputRef.current?.value || '';
      setPayloadShopSite((prevPayload: any) => ({
        ...prevPayload,
        start: newCount,
        term: currentSearchTerm
      }));
     // console.log("Current search term:", currentSearchTerm); // 用于调试
      return newCount;
    });
  }

  useEffect(() => {
    checkShopSite(shopSiteName);
  }, [shopSiteName]);

  useEffect(() => {
    setLoading(true);
    setIsDataFetched(false); // 请求开始时设置为 false
    if (payloadShopSite && payloadShopSite['vendor_id'] === 'shop.com')
    getItemShopComService(payloadShopSite)
      .then((item: any) => {
        if (payloadShopSite.start > 0) {
          // 只有当搜索条件相同时才合并数据
          if (payloadShopSite.term === shopComAllData.searchTerm) {
            const mergedData = {
              ...item,
              products: [...shopComAllData.products, ...item.products],
              searchTerm: payloadShopSite.term // 保存搜索条件
            };
            dispatch(setShopComAllData(mergedData));
          } else {
            // 如果搜索条件改变，直接使用新数据
            const newData = {
              ...item,
              searchTerm: payloadShopSite.term
            };
            dispatch(setShopComAllData(newData));
          }
        } else {
          // start === 0 时是新搜索，直接使用新数据
          const newData = {
            ...item,
            searchTerm: payloadShopSite.term
          };
          dispatch(setShopComAllData(newData));
        }
        setProductsCategoryTotal(item["categories"]);
        setProductsBrandTotal(getTrademarkOutput(item["brands"]));
        setLoading(false);
        setIsDataFetched(true); // 请求成功后设置为 true
      })
      .catch((err) => {
       // console.log("API shop COM error:", err);
        setIsDataFetched(true); // 即使请求失败也设置为 true
        setLoading(false);
      });
  }, [payloadShopSite]);

  useEffect(() => {
    dispatch(setInteractionData(interactionDataArray));
    saveInteractionAPI(
      configurationData?.stream_id,
      interactionDataArray
      // interactionDataArray.filter(
      //   (data: any) => data.attributes.shouldShow === true
      // )
    );
  }, [interactionDataArray]);

  useEffect(() => {
    if (interactionData.length > 0) {
      setInteractionDataArray(interactionData);
    }

  }, []);

  useEffect(() => {
    const container = document.getElementById('list-container');

    if (container && !listenerAdded) {
      listenerAdded = true;
      container?.addEventListener('scroll', function() {
        if (container.scrollTop + container.clientHeight >= container.scrollHeight - 30) {
          if (timeoutId) {
            clearTimeout(timeoutId);
          }
          // timeoutId = setTimeout(() => {
          //   getMoreItem();
          // }, 200);
          timeoutId = setTimeout(() => {
            getMoreItem();
          }, 600);
        }
      });
    }
    
  },[loading]);

  useEffect(() => {
    if (productMoreData) {
      const uniqueProductIds = new Set();
      const totalProducts = []?.concat(
        ...productMoreData?.filter((arr:any) => arr !== undefined)
      );
      const uniqueProducts = totalProducts.filter((product: any) => {
        if (!uniqueProductIds.has(product.id)) {
          uniqueProductIds.add(product.id);
          return true;
        }
        return false;
      });
      setProductsDetailData([...uniqueProducts]);
    }
  }, [productMoreData]);

  useEffect(() => {
    // if (searchTerm) {
    //   setProductsDetailData(
    //     searchItems(shopComAllData["products"], searchTerm)
    //   );
    // } else {
      setProductsDetailData(shopComAllData["products"]);
     // console.log("shopComAllData==>", shopComAllData);
    // }
  }, [shopComAllData]);

  useEffect(() => {
    if (productsBrandTemp !== null) {
      setProductMoreData([]); // 清空累积的产品数据
      setProductsDetailData([]); // 清空显示的产品数据
      handleSelectBrand();
    }
  }, [productsBrandTemp]);

  useEffect(() => {
    if (productsCategoryTemp !== null) {
      setProductMoreData([]); // 清空累积的产品数据
      setProductsDetailData([]); // 清空显示的产品数据
      handleSelectCategory();
    }
  }, [productsCategoryTemp]);

  useEffect(() => {
    if (productsCategorySubTemp !== null) {
      setProductMoreData([]); // 清空累积的产品数据
      setProductsDetailData([]); // 清空显示的产品数据
      handleSelectCategorySub();
    }
  }, [productsCategorySubTemp]);

  // 修改 debouncedSearch 函数
  const debouncedSearch = useCallback(
    debounce((searchTerm: string) => {
      // 清空之前的搜索记录
      setProductMoreData([]); // 清空累积的产品数据
      setProductsDetailData([]); // 清空显示的产品数据
      
      // 重置搜索条件
      setPayloadShopSite((prev:any) => ({
        ...prev,
        term: searchTerm,
        start: 0
      }));
      handleFilterData();
    }, 300),
    []
  );

  // 修改 handleSearch 函数
  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newSearchTerm = event.target.value;
    setSearchTerm(newSearchTerm);  // 立即更新输入框的值
    setCount(0);  // 重置计数
    debouncedSearch(newSearchTerm);  // 使用防抖处理 API 调用
  };

  // 在组件卸载时取消所有未执行的防抖函数
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, []);

  const siteNameHandler = (siteName: any) => {
    if (!siteName) return "unknown";
    switch (true) {
        case isMarketAmericaShopUrl(siteName):
            return "shop";
        case siteName.includes('nutrametrix.com'):
            return "nutrametrix";
        case siteName.includes('isotonix.com'):
            return "isotonix";
        case siteName.includes('tlsslim.com'):
            return "transitions";
        case siteName.includes('motivescosmetics.com'):
            return "motives";
        case siteName.includes('lumieredevie.com'):
            return "lumiere";
        case siteName.includes('getlayered.com'):
            return "layered";
        default:
            return "unknown";
    }
  };

  const addInteractionDataToArray = (item: any) => {
   // console.log("shopItem==>", item);
    selectedItems.forEach((item: any) => {
      var resp = createStreamData;
      if (resp && resp['metadata'] && resp['metadata']['attendees'] && resp['metadata']['attendees'].filter((p: { role: string; })=> p.role == 'host')) {
      var hostInfo = resp['metadata']['attendees'].filter((p: { role: string; })=> p.role == 'host')[0];
      callEvent([{"event_data":{
        "attendee_email":hostInfo["email"],
        "attendee_first":hostInfo["given_name"],
        "attendee_id":hostInfo["attendee_id"],
        "attendee_role":"attendee",
        "attendee_last":hostInfo["family_name"]+ " (host)",
        "client_id":hostInfo.attendee_id.split('|')[0],
        "stream_id":joinWithAttendeeData['stream_id'],
        "stream_instance_id":resp["stream_instance_id"],
        "user_id":hostInfo.attendee_id.split('|')[1],
        "interaction_id": item?.id,
        "interaction_type": "media",
        "interaction_label": item?.name,
        "interaction_action": item?.shopUrl,
        "interaction_imageUrl": item?.imageUrl,
        "elapsed_seconds":hostTime,
        "date":new Date().toUTCString()},
        "event_type":"interaction_created"}]);
      }
      setInteractionDataArray((prevArray) => [
        ...prevArray,
        {
          attributes: {
            action: item?.shopUrl,
            label: item?.name,
            isLinkedToStore: false,
            assetId: `${item?.id}`,
            description: item?.description,
            price:
              item?.maximumPrice == item?.minimumPrice
                ? item?.minimumPriceString
                : `${item?.minimumPriceString}-${item?.maximumPriceString}`,
            createdOn: `${time}`,
            isDefault: false,
            eCommerce: false,
            shouldShow: true,
            labelVisible: true,
            thirdPartyUsername: "",
            isProduct: true,
            productMaxPrice: item?.maximumPrice,
            productMinPrice: item?.minimumPrice,
            opContainerId:item?.opContainerId,
            zyiaSymbolSuffix: "",
            siteName: `${siteNameHandler(item?.shopUrl)}`,
            hostUserName: "",
            isMAShop: true,
            rotatable: true,
            draggable: true,
            scalable: true,
            deletable: true,
            editable: true,
            iframeable: true,
            maximumPriceString: item?.maximumPrice,
            minimumPriceString: item?.minimumPrice,
          },
          style: {
            style_type: "photo",
            pulse_animation: false,
            opacity: 1,
            thumbnail_url: item?.imageUrl,
          },
          center_x: 50,
          center_y: 50,
          rotation_angle: 0,
          start: 0,
          end: 5,
          height_max: 100,
          height_pc: 17,
          interaction_id: `${item?.id}`,
          interaction_subtype: "other",
          interaction_type: siteNameHandler(item?.shopUrl) == 'shop' ? "shop_com" :  "media",
          width_max: 100,
          width_pc: 8,
          featured: false,
        },
      ]);
    });

    setSelectedItems([]);

    setTimeout(() => {
      props.handleCloseMediaInteraction(true);
    }, 200);
  };

  const checkElementPresentInArray = (id: any) => {
    return interactionDataArray.some(
      (element: any) => element.interaction_id == id
    );
  };

  function getTrademarkSymbol(trademark: any) {
    if (trademark?.includes("&reg;")) {
      return "®";
    } else if (trademark.includes("&trade;")) {
      return "™";
    } else {
      return "";
    }
  }
  function removeHtmlEntities(str: any) {
    return str.replace(/&[^;]+;/g, "");
  }

  function getTrademarkOutput(trademarks: any) {
    return trademarks?.map((trademark: any) => {
      return {
        brandId: trademark.brandId,
        brandName:
          removeHtmlEntities(trademark.brandName) +
          getTrademarkSymbol(trademark.brandName),
      };
    });
  }

  return (
    <Modal
      isOpen={props.modalIsOpen}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <div className="flex w-full h-full bg-neutral-800 " id={"ModalInner"}>
        <div className="flex flex-col w-full bg-black  rounded-lg p-4">
          <span className="text-white text-4xl font-medium">
            {checkShopSiteTitle(shopSiteName)}
          </span>
          <div className="w-full bg-white h-0.5 my-2" />
          <div>
            <span className="text-white">
              {language['select_products_prompt']}
            </span>
          </div>
          <div className="flex flex-row my-4 w-full" style={{ zIndex: 1 }}>
            <div>              
            <SelectListBrand
                defaultSelectedItem={{
                  brandId: "all",
                  brandName: language['select_brand'],
                }}
                data={productsBrandTotal}
                onSelect={(item: any) => {
                  setProductsBrandTemp(item);
                }}
                ref={childeBrandRef}
                onCloseOtherList={() => {
                  childeCatRef?.current?.handleCloseListDisplay();
                  childeSubCatRef?.current?.handleCloseListDisplay();
                }}
              />
            </div>
            <div className="ml-10">
              <SelectListCategories
                defaultSelectedItem={language['select_categories']}
                data={productsCategoryTotal}
                onSelect={(item: any) => {
                  setProductsCategoryTemp(item);
                }}
                ref={childeCatRef}
                onCloseOtherList={() => {
                  childeBrandRef?.current?.handleCloseListDisplay();
                  childeSubCatRef?.current?.handleCloseListDisplay();
                }}
              />
            </div>

            <div className="ml-10">
              <SelectListCategoriesSub
                defaultSelectedItem={language['select_sub_categories']}
                data={productsCategorySub}
                onSelect={(item: any) => {
                  setProductsCategorySubTemp(item);
                }}
                ref={childeSubCatRef}
                onCloseOtherList={() => {
                  childeBrandRef?.current?.handleCloseListDisplay();
                  childeCatRef?.current?.handleCloseListDisplay();
                }}
              />
            </div>

            <div className="flex flex-row border-2 border-zinc-700 rounded-lg ml-6 items-center justify-center px-4 search-container">
              <BiSearch fill="white" size="24" />
              <input
                className="bg-black w-52 text-white pl-2 outline-none placeholder:text-white"
                placeholder={language['search_label']}
                onChange={handleSearch}
                ref={inputRef}
              />
            </div>

            <div className="items-center absolute right-4 top-3 ">
              <TfiClose
                onClick={closeModal}
                color="#DEDEDE"
                size={30}
                cursor="pointer"
              />
            </div>
          </div>
          {/* overflow-y-scroll no-scrollbar */}
          <div id="list-container" className="h-full w-full overflow-y-scroll containerModal">
            {loading ? (
              <div className="flex justify-center items-center h-full">
                <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-white"></div>
              </div>
            ) : productsDetailData && productsDetailData.length == 0 && isDataFetched ? (
              <NoResult></NoResult>
            ) : (
              <>
                <div className="grid grid-cols-6 gap-2 ">
                  {productsDetailData?.map((item: any, index) => {
                    const isSelected = selectedItems.includes(item);

                    return (
                      <div
                        className={`flex flex-col p-2 ${
                          isSelected ? "selected-item" : ""
                        }`}
                        key={item?.id}
                        onClick={() => handleSelectItem(item)}
                      >
                        <div className="rounded-lg inset-0 w-full h-44 bg-zinc-300">
                          {isSelected && <div className={`selected-indicator` } 
                            style={{backgroundColor: `${getBrandColor(client)} `}}

                          />}

                          <img
                            className="h-full w-full object-cover object-center rounded-lg"
                            src={`${item?.imageUrl}`}
                            onError={(event) => {
                              event.currentTarget.src =
                                "https://andersnoren.se/themes/koji/wp-content/themes/koji/assets/images/default-fallback-image.png";
                            }}
                            alt=""
                          />
                        </div>
                        <div className="text-white mt-2 line-clamp-2">
                          <div dangerouslySetInnerHTML={{ __html: item?.name }} />
                          {/* {item?.name} */}
                        </div>
                        {/* <div className="text-white mt-2 line-clamp-2">
                        {item?.description}
                      </div> */}
                        <div className="text-white mt-2 line-clamp-2 text-base font-medium">
                          {/* ${item?.minimumPrice} - ${item?.maximumPrice} */}
                          {item?.maximumPrice == item?.minimumPrice
                            ? item?.minimumPriceString
                            : `${item?.minimumPriceString} - ${item?.maximumPriceString}`}
                        </div>
                      </div>
                    );
                  })}
                </div>
                {selectedItems.length > 0 && (
                  <div
                    className={`h-12 w-64 flex items-center justify-center rounded-lg ml-[40%] cursor-pointer fixed bottom-4`}                    
                    onClick={() => {
                      addInteractionDataToArray(selectedItems);
                      // selectedItems.forEach((item:any) => {
                      //   var resp = createStreamData;
                      //   var data = item;
                      //   if (data.attributes && resp && resp['metadata'] && resp['metadata']['attendees'] && resp['metadata']['attendees'].filter((p: { role: string; })=> p.role == 'host')) {
                      //   callEvent([{"event_data":{
                      //     "attendee_email":resp["email"],
                      //     "attendee_first":resp["given_name"],
                      //     "attendee_id":resp["attendee_id"],
                      //     "attendee_role":"attendee",
                      //     "attendee_last":resp["family_name"]+ " (host)",
                      //     "client_id":resp['metadata']['attendees'].filter((p: { role: string; })=> p.role == 'host')[0].attendee_id.split('|')[0],
                      //     "stream_id":joinWithAttendeeData['stream_id'],
                      //     "stream_instance_id":resp["stream_instance_id"],
                      //     "user_id":resp['metadata']['attendees'].filter((p: { role: string; }) => p.role == 'host')[0].attendee_id.split('|')[1],
                      //     "interaction_id": data.interaction_id,
                      //     "interaction_type": data.attributes.type,
                      //     "interaction_label": data.attributes.label,
                      //     "interaction_action": data.attributes.action,
                      //     "interaction_imageUrl": data.style.thumbnail_url,
                      //     "elapsed_seconds":hostTime,
                      //     "date":new Date().toUTCString()},
                      //     "event_type":"interaction_created"}]);
                      //   }
                      // });
                    }}
                    style={{backgroundColor: `${getBrandColor(client)} `}}
                  >
                    <span className="text-white text-2xl">{language['add_button']}</span>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {/* <h2 ref={(_subtitle) => (subtitle = _subtitle)}>Hello</h2>
        <button onClick={closeModal}>close</button>
        <div>I am a modal</div>
        <form>
          <input />
          <button>tab navigation</button>
          <button>stays</button>
          <button>inside</button>
          <button>the modal</button>
        </form> */}
    </Modal>
  );
}

export default InteractionShop;